module.exports = __webpack_public_path__ + "static/onlineDocuments-849d05e2eda86bd0f05c29e5539a4ba8.svg";